<div class="ion-margin-top">
  <ng-container>
    <ion-row class="ion-text-center" *ngIf="platform.is('capacitor')">
      <ion-col>
        <ion-button
          icon-left
          fill="clear"
          color="dark"
          fill="outline"
          (click)="onImportPhoto()"
          [disabled]="isReadOnly"
        >
          <ion-icon name="image"></ion-icon>Import photo
        </ion-button>
      </ion-col>
      <ion-col>
        <ion-button fill="clear" color="dark" (click)="onCapturePhoto()" [disabled]="isReadOnly">
          <ion-icon name="camera"></ion-icon> Take photo
        </ion-button>
      </ion-col>
    </ion-row>

    <smr-booking-photos
      [isReadOnly]="isReadOnly"
      [client]="client"
      [clientPhotos]="clientPhotos"
      [content]="content"
      (viewPhoto)="onViewPhoto($event)"
      (profilePhoto)="setProfilePhoto($event)"
    >
    </smr-booking-photos>
  </ng-container>
</div>
